<template>
    <form @submit.prevent="submit" ref="form">
        <text-input v-model="form.name" :errors="$page.props.errors.name" class="mb-3" label="Naam" />

        <select-input
            :value="form.category"
            v-model="form.category"
            :options="Object.values(categories)"
            :error="$page.props.errors.tag_category_id"
            class="mb-3"
            label="Rubriek"
        ></select-input>

        <label class="form-label mt-6">Toon in footer:</label>
        <select
            v-model="form.showInFooter"
            class="form-input block appearance-none w-full py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
        >
            <option :value="false">Nee</option>
            <option :value="true">Ja</option>
        </select>

        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
        </div>

        <h2 class="font-bold text-xl mt-6 border-t pt-5">SEO teksten</h2>

        <text-input v-model="form.seo_title" :errors="$page.props.errors.seo_title" class="mt-3 mb-3" label="Title tag" type="text" />

        <textarea-input v-model="form.seo_description" :errors="$page.props.errors.seo_description" class="mb-3" label="Meta description" :autosize="true"/>

        <wysiwyg :value="form.seotext1" v-model="form.seotext1" :error="$page.props.errors.seotext1" label="SEO tekst boven" :insert-media="false" imageable-type="tag"></wysiwyg>

        <wysiwyg :value="form.seotext2" v-model="form.seotext2" :error="$page.props.errors.seotext2" label="SEO tekst beneden"></wysiwyg>

        <button type="submit" class="mt-5 text-white bg-teal-700 px-5 py-3 rounded inline-block hover:bg-teal-800 focus:bg-teal-800">
            <i class="fal mr-1" :class="loading == 'submit' ? 'fa-spinner fa-spin' : 'fa-save'"></i>Opslaan
        </button>
    </form>
</template>

<script>
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Layout from "@/admin/Shared/Layout";
import TextInput from "@/admin/Shared/TextInput";
import FileInput from "@/admin/Shared/FileInput";
import SelectInput from "@/admin/Shared/SelectInput";
import wysiwyg from "@/admin/Shared/WYSIWYG";
import TextareaInput from "@/admin/Shared/TextareaInput";

export default {
    components: {
        TextInput,
        TextareaInput,
        FileInput,
        SelectInput,
        wysiwyg
    },

    mixins: [Helpers],

    props: {
        dataLoading: false,
        categories: Array,
        tag: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    watch: {
        dataLoading: function(loading) {
            this.loading = loading;
        }
    },

    data() {
        return {
            form: {
                name: this.tag.name || "",
                category: this.tag.category || null,
                seotext1: this.tag.seotext1 || "",
                seotext2: this.tag.seotext2 || "",
                seo_title: this.tag.seo_title || "",
                seo_description: this.tag.seo_description || "",
                showInFooter: this.tag.show_in_footer
            }
        };
    },

    methods: {
        submit() {
            let data = {
                name: this.form.name,
                tag_category_id: this.form.category ? this.form.category.id : null,
                seotext1: this.form.seotext1,
                seotext2: this.form.seotext2,
                seo_title: this.form.seo_title,
                seo_description: this.form.seo_description,
                show_in_footer: this.form.showInFooter
            };

            this.$emit("submit", data);
        }
    }
};
</script>
